<template>
    <div>
<!--body content start-->

<div id="main-page" class="page-content">

<section>
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="masonry row popup-gallery no-gutters">
          <div class="grid-sizer"></div>
          <div class="masonry-brick col-lg-4 col-md-6">
            <div class="portfolio-item">
              <img class="img-fluid w-100" src="images/portfolio/01.jpg" alt="">
              <a class="popup-img" href="images/portfolio/large/01.jpg"> <i class="fas fa-plus-circle"></i>
              </a>
              <div class="portfolio-hover"> <span>Design</span>
                <h5><a href="portfolio-single.html">Creative Design</a></h5>
              </div>              
            </div>
          </div>
          <div class="masonry-brick col-lg-8 col-md-6">
            <div class="portfolio-item">
              <img class="img-fluid w-100" src="images/portfolio/02.jpg" alt="">
              <a class="popup-img" href="images/portfolio/large/02.jpg"> <i class="fas fa-plus-circle"></i>
              </a>
              <div class="portfolio-hover"> <span>App</span>
                <h5><a href="portfolio-single.html">Mobile Ui</a></h5>
              </div>              
            </div>
          </div>
          <div class="masonry-brick col-lg-4 col-md-6">
            <div class="portfolio-item">
              <img class="img-fluid w-100" src="images/portfolio/03.jpg" alt="">
              <a class="popup-img" href="images/portfolio/large/03.jpg"> <i class="fas fa-plus-circle"></i>
              </a>
              <div class="portfolio-hover"> <span>Branding</span>
                <h5><a href="portfolio-single.html">Design Mockup</a></h5>
              </div>              
            </div>
          </div>
          <div class="masonry-brick col-lg-4 col-md-6">
            <div class="portfolio-item">
              <img class="img-fluid w-100" src="images/portfolio/04.jpg" alt="">
              <a class="popup-img" href="images/portfolio/large/04.jpg"> <i class="fas fa-plus-circle"></i>
              </a>
              <div class="portfolio-hover"> <span>App</span>
                <h5><a href="portfolio-single.html">Mobile Screen</a></h5>
              </div>              
            </div>
          </div>
          <div class="masonry-brick col-lg-8 col-md-6">
            <div class="portfolio-item">
              <img class="img-fluid w-100" src="images/portfolio/07.jpg" alt="">
              <a class="popup-img" href="images/portfolio/large/02.jpg"> <i class="fas fa-plus-circle"></i>
              </a>
              <div class="portfolio-hover"> <span>Branding</span>
                <h5><a href="portfolio-single.html">Creative Cake</a></h5>
              </div>              
            </div>
          </div>
          <div class="masonry-brick col-lg-4 col-md-6">
            <div class="portfolio-item">
              <img class="img-fluid w-100" src="images/portfolio/05.jpg" alt="">
              <a class="popup-img" href="images/portfolio/large/05.jpg"> <i class="fas fa-plus-circle"></i>
              </a>
              <div class="portfolio-hover"> <span>Design</span>
                <h5><a href="portfolio-single.html">Social Media</a></h5>
              </div>              
            </div>
          </div>
          <div class="masonry-brick col-lg-4 col-md-6">
            <div class="portfolio-item">
              <img class="img-fluid w-100" src="images/portfolio/06.jpg" alt="">
              <a class="popup-img" href="images/portfolio/large/06.jpg"> <i class="fas fa-plus-circle"></i>
              </a>
              <div class="portfolio-hover"> <span>Design</span>
                <h5><a href="portfolio-single.html">Development</a></h5>
              </div>              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

</div>

<!--body content end--> 
    </div>
</template>

<script>
// @ is an alias to /src

export default {
  data: function () {
        return {
            name: "portfolio Masonry",
        }
    }
};
</script>
